import { __rest } from 'tslib';
import React, { useState, useMemo } from 'react';
import { space } from 'styled-system';
import { s as styled } from './styled-112a8bd0.js';
import { B as ButtonChevron } from './ButtonChevron-5b0d053f.js';
import { D as Dropdown, a as DropdownToggle, b as DropdownMenu } from './DropdownMenu-95763579.js';

const ListItem = styled.li(({ selected, theme }) => `
    padding: 0.6rem 0.8rem;
    font-size: 14px;
    background-color: ${selected ? '#f7f7f7' : ''};
    color: ${selected ? theme.brand.primary : 'inherit'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #f7f7f7;
      color: ${theme.brand.primary};
      cursor: pointer;
    }
  `);
const Text = styled.span `
  font-size: 0.875rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  margin-right: 0.25rem;
  text-align: left;
`;
const Content = styled.ul `
  border-radius: 0.25rem;
  border: 1px solid #e0e0e0;
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  box-shadow: 2px 2px 0.8rem 0 rgba(0, 0, 0, 0.08);
  overflow-y: auto;
`;
const Wrapper = styled.div(space, `
    width: 100%;
`);
const StyledButtonChevron = styled(ButtonChevron) `
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: white;
  border-radius: 0.25rem;
  border-color: #e0e0e0;
`;
const StyledDropdown = styled(Dropdown) `
  width: 100%;
  button {
    ${(p) => p.disabled
    ? `
      background-color: #f8f8fc;
      cursor: not-allowed;`
    : ''}
    > span:first-child {
      flex: 1;
      text-align: left;
    }
  }
`;
const sameWidthModifier = {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => {
        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
    },
};
const dropdownConfigs = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [0, 10],
            },
        },
    ],
};
const Select = (_a) => {
    var { title, onChange, items, selectedValue = null, variant, sameWidth = true, disabled = false } = _a, props = __rest(_a, ["title", "onChange", "items", "selectedValue", "variant", "sameWidth", "disabled"]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const handleChange = ({ value }) => () => {
        setDropdownOpen(false);
        onChange(value);
    };
    const toggle = () => !disabled && setDropdownOpen((prevState) => !prevState);
    const currentTitle = useMemo(() => {
        if (selectedValue === null) {
            return title;
        }
        const filteredItems = items.filter(({ value }) => value === selectedValue);
        return filteredItems.length > 0 ? filteredItems[0].content : title;
    }, [items, selectedValue, title]);
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(StyledDropdown, { isOpen: dropdownOpen, disabled: disabled, toggle: toggle },
            React.createElement(DropdownToggle, null,
                React.createElement(StyledButtonChevron, { type: "button", direction: dropdownOpen ? 'up' : 'down', variant: variant === 'invalid' ? 'danger' : undefined, outline: true },
                    React.createElement(Text, null, currentTitle))),
            React.createElement(DropdownMenu, { popperConfig: Object.assign(Object.assign({}, dropdownConfigs), { modifiers: [
                        ...dropdownConfigs.modifiers,
                        sameWidth && sameWidthModifier,
                    ] }) },
                React.createElement(Content, null, items.map(({ content, value }, index) => (React.createElement(ListItem, { onClick: handleChange({ content, value }), selected: value === selectedValue, key: index }, content))))))));
};

export { Select as S };
